<template>
  <div :class="{ 'nav-box': isHeight,'nav-box-act': isHover}">
    <div
    class="pc"
      :class="{ 'header-box': true }"
      :style="{ backgroundColor: backgroundColor }"
    >
      <img
        class="logo"
        src="@/assets/nav/DF-logo.png"
        alt=""
        @click="toUrl('/')"
      />
      <div class="right-box">
        <div class="previous-menu menu-one">
          关于DF
          <div class="below-box">
            <img src="@/assets/nav/sanjiao.png" alt="" />
            <div class="pull-down-box">
              <div
                :class="{
                  'menu-item': true,
                  activeColor: $path == '/about-df/about-brand',
                }"
                @click="toUrl('/about-df/about-brand')"
              >
                关于品牌
                <div class="line"></div>
              </div>
              <div
                :class="{
                  'menu-item': true,
                  activeColor: $path == '/about-df/consult',
                }"
                @click="toUrl('/about-df/consult')"
              >
                最新资讯
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="previous-menu menu-two">
          DF旗舰店
          <div class="below-box">
            <img src="@/assets/nav/sanjiao.png" alt="" />
            <div class="pull-down-box">
              <div
                :class="{
                  'menu-item': true,
                  activeColor: $path == '/flagship-store/xx',
                }"
                @click="toUrl('/flagship-store/xx')"
              >
                线下旗舰店
                <div class="line"></div>
              </div>
              <div
                :class="{
                  'menu-item': true,
                  activeColor: $path == '/flagship-store/online-store',
                }"
                @click="toUrl('/flagship-store/online-store')"
              >
                线上旗舰店
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="previous-menu menu-three">
          DF产品
          <div class="below-box">
            <img src="@/assets/nav/sanjiao.png" alt="" />
            <div class="pull-down-box">
              <div
                :class="{
                  'menu-item': true,
                  activeColor: $path == '/product/series'&&current==0,
                }"
                @click="toProduct(0)"
              >
                乘用车用户
                <div class="line"></div>
              </div>
              <div
                :class="{
                  'menu-item': true,
                  activeColor: $path == '/product/series'&&current==1,
                }"
                @click="toProduct(1)"
              >
                商用车用户
                <div class="line"></div>
              </div>
              <div
                :class="{
                  'menu-item': true,
                  activeColor: $path == '/product/series'&&current==2,
                }"
                @click="toProduct(2)"
              >
                农机轻卡用户
                <div class="line"></div>
              </div>
              <div
                :class="{
                  'menu-item': true,
                  activeColor: $path == '/product/series'&&current==3,
                }"
                @click="toProduct(3)"
              >
                船舶用户
                <div class="line"></div>
              </div>
              <div
                :class="{
                  'menu-item': true,
                  activeColor: $path == '/product/series'&&current==4,
                }"
                @click="toProduct(4)"
              >
                工程机械用户
                <div class="line"></div>
              </div>
              <!-- <div :class="{'menu-item':true,'activeColor':$path=='/product/rests'}" @click="toUrl('/product/series')">
                                其他
                                <div class="line"></div>
                            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-nav phone">
      <div class="mobile-nav-top">
        <div class="logo" @click="toUrl('/')">
          <img src="@/assets/nav/phone/logo.webp">
        </div>
        <div class="menus">
          <img class="menu" @click="isHover=true" src="@/assets/nav/phone/menu.webp">
          <img class="close" @click="isHover=false" src="@/assets/nav/phone/close.webp">
        </div>
      </div>
      <div class="mobile-nav-content">
        <!-- <div class="search" v-if="false">
          <img src="@/assets/nav/phone/search.webp">
          <input>
        </div> -->

        <div class="list">
          <div class="list-item" :class="{'listItemACt':item.isExpand}" v-for="(item,index) in list" :key="index" @click="handleExpand(item,index)">
            <div class="list-item-top">
              <span> {{ item.title }}</span>
              <img src="@/assets/nav/phone/arrow.webp">
            </div>
            <div class="item-child" v-if="item.children&&item.children.length>0">
              <div class="" v-for="(v,i) in item.children" :key="i" @click="toPath(index,v)">
                {{ v.title }}
              </div>
            </div>
          </div>
          <div class="list-item">
            <div class="list-item-top" @click="toUrl('/support/download')">
              <span>物料下载中心</span>
            </div>
          </div>
          <div class="list-item" @click="toUrl('/support/to-join')">
            <div class="list-item-top">
              <span>申请旗舰店</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isHeight: {
      type: Boolean,
      default: true,
    },
    backgroundColor: {
      type: String,
      default: "#FFF337",
    },
    scrollTop: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isShow: false,
      open: false,
      animation: false,
      activeName: "1",
      isHover:false,
      list:[
        {
          title:"关于DF",
          isExpand:false,
          children:[
            {
              title:"关于品牌",
              url:"/about-df/about-brand",
            },
            {
              title:"最新资讯",
              url:"/about-df/consult",
            }
          ]
        },
        {
          title:"DF旗舰店",
          isExpand:false,
          children:[
            {
              title:"线下旗舰店",
              url:"/flagship-store/xx",
            },
            {
              title:"线上旗舰店",
              url:"/flagship-store/online-store",
            }
          ]
        },
        {
          title:"DF产品",
          isExpand:false,
          children:[
            {
              title:"乘用车用户",
              url:"/product/series",
              type:0,
            },
            {
              title:"商用车用户",
              url:"/product/series",
              type:1,
            },
            {
              title:"农机轻卡用户",
              url:"/product/series",
              type:2,
            },
            {
              title:"船舶用户",
              url:"/product/series",
              type:3,
            },
            {
              title:"工程机械用户",
              url:"/product/series",
              type:4,
            },
          ]
        },
      ],
    };
  },
  computed:{
    current(val){
        return this.$store.state.productCurrent
    }
  },
  mounted() {
    let that = this;
    // window.addEventListener("scroll", function () {
    //     // 获取滚动条滚动距离
    //     var scrollTop =
    //         document.documentElement.scrollTop || document.body.scrollTop;
    //     if (scrollTop > 500) {
    //         that.isShow = true;
    //     }else{
    //         that.isShow = false;
    //     }
    // });
  },
  methods: {
    handleExpand(item,index){
      this.$nextTick(()=>{
        this.list[index].isExpand=!item.isExpand
        this.list.filter((v,i)=>{
          if(i!=index){
            v.isExpand=false
          }
        })
      })
    },
    toPath(index,item){
      this.isHover=false
      if(index==2){
        this.toProduct(item.type)
        return
      }
      this.toUrl(item.url)
    },
    toUrl(path) {
      this.$router.push(
        {
          path,
        },
        () => {
         
        }
      );
    },
    toProduct(index) {

      this.$router.push(
        {
          path: "/product/series",
          query: {
            current: index,
          },
        },
        () => {
          
            this.$store.commit('setProductCurrent',index)
        }
      );
    },
    handle(type) {
      this.open = !this.open;
    },

  },
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 768px) {
  .phone{
        display: none !important;
    }
.nav-box {
  height: 0.8rem;
}
.header-box {
  position: fixed;
  width: 100%;
  height: 0.8rem;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // background: rgba(255, 255, 255, 1);
  transition-duration: 1s;

  .logo {
    // position: absolute;
    // left: 1.25rem;
    // top: 0.35rem;
    margin-left: 1.02rem;
    width: 1.08rem;
    height: 0.38rem;
  }

  .right-box {
    height: 100%;
    display: flex;
    align-items: center;
    margin-right: 0.5rem;

    .previous-menu {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1.5rem;
      height: 100%;
      text-align: center;
      font-size: 0.2rem;
      color: #000000;
      cursor: pointer;
      position: relative;

      .below-box {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 0;
        opacity: 0;
        visibility: hidden;
        border-radius: 2px;
        transition-duration: 0.3s;
        box-sizing: border-box;
        overflow: hidden;

        img {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 0.12rem;
          height: 0.06rem;
        }
      }

      .pull-down-box {
        margin-top: 0.06rem;
        width: 100%;
        height: 0;
        opacity: 0;
        visibility: hidden;
        background: #000000;
        border-radius: 2px;
        transition-duration: 0.3s;
        padding: 0.15rem;
        box-sizing: border-box;
        overflow: hidden;

        .menu-item {
          position: relative;
          width: 100%;
          height: 0.5rem;
          line-height: 0.5rem;
          font-size: 0.18rem;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #ffffff;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          transition-duration: 1s;

          .line {
            position: absolute;
            top: 0.4rem;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0.02rem;
            background: #fff337;
            transition-duration: 0.3s;
          }
        }
        .activeColor {
          color: #fff337;
        }
        .menu-item:hover {
          color: #fff337;

          .line {
            width: 60%;
          }
        }
      }
    }

    .menu-two {
      .pull-down-box {
        overflow: visible;

        .menu-item:hover {
          color: #fff337;

          .line {
            width: 70%;
          }
        }
      }
    }

    .previous-menu:hover {
      font-weight: bold;

      .below-box {
        height: 1.36rem;
        opacity: 1;
        visibility: visible;
      }

      .pull-down-box,
      .below-box {
        height: 1.3rem;
        opacity: 1;
        visibility: visible;
      }
    }
    .menu-three:hover {
      .pull-down-box,
      .below-box {
        height: 2.8rem;
        opacity: 1;
        visibility: visible;
      }
    }
  }
}
.header-bg {
  background: #fff337 !important;
}

.color {
  background: rgba(255, 255, 255, 0.3);
}

.mobile-nav::before {
  display: table;
  content: "";
  clear: both;
}

.mobile-nav {
  .logo {
    position: absolute;
    top: 1.25rem;
    left: 1.25rem;
    width: 6.7rem;
    height: 2.4rem;
    z-index: 98;
  }

  .menu-icon {
    position: fixed;
    right: 20px;
    top: 20px;
    width: 32px;
    height: 32px;
    z-index: 100;
  }

  .add {
    background: url("~@/assets/nav/add.png") no-repeat;
    background-size: 100% 100%;
  }

  .mius {
    background: url("~@/assets/nav/mius.png") no-repeat;
    background-size: 100% 100%;
  }

  .menu-box {
    // padding-top: 60px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    background: #ffffff;
    overflow-y: scroll;
    transition-duration: 1s;
    z-index: 99;

    ::v-deep .van-collapse {
      .van-collapse-item-1 {
        width: 100%;
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .van-collapse-item-1 + .van-collapse-item-1 {
        border-top: 1px solid #ebedf0;
      }
    }
  }

  .height {
    height: 100vh;
  }
}
}

@media screen and (max-width: 767px) {

.nav-box {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 999;
  height: 1.2rem;
  overflow: hidden;
  .mobile-nav{
    &-top{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:0 0.4rem;
      height: 1.2rem;
      background: #FFF337;
      .logo{
        img{
          width: 1.42rem;
          height: 0.48rem;
        }
      }
      .menus{
        .menu{
          width: 0.66rem;
          height: 0.34rem;

        }
        .close{
          display: none;
          height: 0.34rem;
          width: 0.34rem;
        }
      }
    }
  }
}
.nav-box-act{
  height: 100vh;
  transition: height .3s ease-in-out;
  background: #FFF337;
  overflow-y: auto;
  .mobile-nav{
    &-top{
      border-bottom: 0.01rem solid #000;
      .menu{
        display: none;
      }
      .close{
        display: block !important;
      }
    }
    &-content{
      padding:0rem 0.4rem;
      .search{
        display: flex;
        height: 0.8rem;
        background: #ffd200;
        align-items: center;
        padding:0 0.3rem;
        img{
          width: 0.42rem;
          height: 0.42rem;
        }
        input{
          flex: 1;
          border: none;
          outline: none;
          height: 0.8rem;
          line-height: 0.8rem;
          background: none !important;
        }
      }
      .list{
        display: flex;
        flex-direction: column;
        &-item{
          border-bottom: 0.01rem solid #000;
          &-top{
            height: 1.3rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span{
              font-family: FZLanTingHeiS-B-GB;
              font-weight: 400;
              font-size: 0.36rem;
              color: #000000;
            }
            img{
              width: 0.22rem;
              height: 0.16rem;
              transition: all .3s ease-in-out;
            }
          }
       
          .item-child{
            height: 0;
            overflow: hidden;
            transition: all .3s ease-in-out;
            div{
              padding-left: 0.6rem;
              font-family: FZLanTingHeiS-R-GB;
              font-weight: 400;
              margin-bottom: 0.6rem;
              font-size: 0.30rem;
              color: #000000;
            }
          }
        }
        .listItemACt{
          img{
            transform: rotate(180deg);
          }
        }
        &-item:nth-child(1).listItemACt,&-item:nth-child(2).listItemACt{
          .item-child{
            height: 1.8rem;
          }
        }
        &-item:nth-child(3).listItemACt{
          .item-child{
            height: 4.8rem;
          }
        }
      }
    }
  }
}
}
</style>